/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import React from "react"
import {
    TYPE_A,
    TYPE_B,
} from "const"
import { SilResultSubsystem } from "server/models"
import { LangType } from "client/store"
import { NotCompliant } from "client/components"

import { diversitySilSubsystem } from "./diversitySubsystem"
import * as Formulas from ".."


export const iec_61508_1998_architecturalConstraints = (
    redundancy: boolean,
    subsystem: SilResultSubsystem,
    lang: LangType,
) => {
    if (redundancy) {
        const hft = Formulas.getHFT(subsystem.architecture)
        const device = subsystem.blocks[0].projectDevice
        const {
            sil,
            type,
            failureRate,
            sd,
            su,
            dd,
            du,
        } = device

        const sff = failureRate
            ? Formulas.sff({ su, sd, du, dd })
            : Formulas.parseProp(device.sff)

        // define SIL Architecture on device level
        const silDevice = sil ? lang[`sil_${sil}`] : Formulas.iec_61508_1998_device({ type, sff, lang, silOnly: true })

        if (type === TYPE_A) {
            if (silDevice === lang.sil_1) {
                if (hft === 0) return lang.sil_1
                if (hft === 1) return lang.sil_2
                if (hft === 2) return lang.sil_3
                return lang.notCompliant
            }
            if (silDevice === lang.sil_2) {
                if (hft === 0) return lang.sil_2
                if (hft === 1) return lang.sil_3
                if (hft === 2) return lang.sil_4
                return lang.notCompliant
            }
            if (silDevice === lang.sil_3) {
                if (hft === 0) return lang.sil_3
                if (hft === 1 || hft === 2) return lang.sil_4
                return lang.notCompliant
            }
            return lang.notCompliant
        }

        if (type === TYPE_B) {
            if (silDevice === <NotCompliant />) {
                if (hft === 0) return lang.notCompliant
                if (hft === 1) return lang.sil_1
                if (hft === 2) return lang.sil_2
                return lang.notCompliant
            }
            if (silDevice === lang.sil_1) {
                if (hft === 0) return lang.sil_1
                if (hft === 1) return lang.sil_2
                if (hft === 2) return lang.sil_3
                return lang.notCompliant
            }
            if (silDevice === lang.sil_2) {
                if (hft === 0) return lang.sil_2
                if (hft === 1) return lang.sil_3
                if (hft === 2) return lang.sil_4
                return lang.notCompliant
            }
            if (silDevice === lang.sil_3) {
                if (hft === 0) return lang.sil_3
                if (hft === 1 || hft === 2) return lang.sil_4
                return lang.notCompliant
            }
            return lang.notCompliant
        }

        return lang.notCompliant
    }

    if (!redundancy) { // diversity - different devices in subsystem
        return diversitySilSubsystem(subsystem, lang)
    }

    return null
}
